import { QuestionAnswerEditorViewModelBase } from '@/features/jobs/questions/QuestionAnswerEditorViewModelBase'
import type {
  BoolAnswer,
  BoolQuestion,
} from '@/features/jobs/questions/questions'
import { action, computed, observable } from 'mobx'
import { QuestionValidationResult } from '@/features/jobs/questions/question-validation-result'

/**
 * Question answer editor for `Bool` questions.
 */
export class BoolQuestionAnswerEditorViewModel extends QuestionAnswerEditorViewModelBase<BoolQuestion> {
  /** @inheritDoc */
  readonly type = 'Bool'

  @observable accessor value: boolean | null = null

  constructor() {
    super()
  }

  /** @inheritDoc */
  @computed get isAnswered() {
    return this.value !== null
  }

  /** @inheritDoc */
  @computed get answer(): BoolAnswer | null {
    return this.value === null ? null : { type: 'Bool', value: this.value }
  }

  /** @inheritDoc */
  @computed get textAnswer() {
    return this.value === null ? null : this.value ? 'Yes' : 'No'
  }

  /** @inheritDoc */
  set(question: BoolQuestion): void {
    this.value = question.answer?.value ?? null
  }

  /** @inheritDoc */
  @action.bound
  respond(value: boolean) {
    this.value = value
    this.notifyAnswerChanged()
    this.notifyContinue()
  }

  /** @inheritDoc */
  validate(): QuestionValidationResult {
    return !this.isAnswered
      ? QuestionValidationResult.failed(['Please select yes or no'])
      : QuestionValidationResult.ok()
  }
}
